import { ButtonText as Buttontext } from '@/utils/global-fonts';
import styled from 'styled-components';

// DEFAULT BUTTON STYLE FOR ALL BUTTONS
const Button = styled.button`
  pointer-events: ${({ loading }) => (loading ? 'none' : 'auto')};
  border: none;
  border-radius: 4px;
  margin: ${({ $margin }) => $margin};
  color: ${({ theme }) => theme.COLOR_WHITE};
  cursor: pointer;
  height: ${({ $buttonHeight }) => $buttonHeight};
  width: ${({ $buttonWidth }) => $buttonWidth};
  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.COLOR_GREY3};
  }
  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.COLOR_PRIMARY_BUTTON_HOVER};
    }
  }
  white-space: nowrap;
`;

// DEFAULT BUTTON TEXT STYLES FOR ALL BUTTONS
const ButtonText = styled(Buttontext)`
  user-select: none;
  margin-right: ${({ icon }) => (icon ? '11px' : '0')};
  color: ${({ theme, disabled }) =>
    disabled ? theme.COLOR_GREY3 : theme.COLOR_WHITE};
`;
const ButtonTextDark = styled(ButtonText)`
  user-select: none;
  color: ${({ theme, disabled }) =>
    disabled ? theme.COLOR_GREY3 : theme.COLOR_BLACK};
  margin-right: ${({ icon }) => (icon ? '11px' : '0')};
  padding: 13px ${({ icon }) => (icon ? '0' : '20px')};
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: center;
`;

// DEFAULT BUTTON CONTAINER STYLES FOR ALL BUTTONS
const InnerButtonContainer = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  text-align: center;
  align-items: center;
`;

// DEFAULT ICON CONTAINER STYLES FOR ALL BUTTONS
const IconContainer = styled.div`
  display: flex;
  margin-right: 7px;
  margin-left: 11px;
`;
const IconContainerRight = styled.span`
  margin: 0 0 0 0;

  .jmpTFE > svg,
  .jmpTFE span > svg {
    margin: 0 0 0 0;
  }
`;

const EttxPrimaryButton = styled(Button)`
  background-color: ${({ theme }) => theme.COLOR_PRIMARY};
  color: ${({ theme, disabled }) =>
    disabled ? theme.COLOR_GREY4 : theme.COLOR_WHITE};
  @media (hover: hover) {
    &:hover,
    &:focus {
      ${({ theme }) => theme.COLOR_PRIMARY};
    }
  }
  @media (hover: none) {
    &:focus {
      ${({ theme }) => theme.COLOR_PRIMARY};
    }
  }
  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.COLOR_GREY};
  }
`;

const EttxPrimaryOutlineButton = styled(Button)`
  border: 1px solid ${({ theme }) => theme.COLOR_BLACK};
  color: ${({ theme, disabled }) =>
    disabled ? theme.COLOR_GREY4 : theme.COLOR_BLACK};
  height: ${({ buttonheight }) => buttonheight};
  outline: 0;
  background-color: ${({ theme }) => theme.COLOR_WHITE};
  @media (hover: hover) {
    &:hover,
    &:focus {
      background-color: ${({ theme }) =>
        theme.COLOR_PRIMARY_OUTLINE_BUTTON_HOVER};
    }
  }
  @media (hover: none) {
    &:focus {
      background-color: ${({ theme }) =>
        theme.COLOR_PRIMARY_OUTLINE_BUTTON_HOVER};
    }
  }
  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.COLOR_WHITE};
    border: 1px solid ${({ theme }) => theme.COLOR_GREY2};
  }
`;

const EttxTextButton = styled(Button)`
  background-color: transparent;
  color: ${({ theme, disabled }) =>
    disabled ? theme.COLOR_GREY4 : theme.COLOR_BLACK};
  @media (hover: hover) {
    &:hover,
    &:focus {
      background-color: transparent;
      color: ${({ theme }) => theme.COLOR_PRIMARY};
      span {
        color: ${({ theme }) => theme.COLOR_PRIMARY};
      }
    }
  }
  @media (hover: none) {
    &:focus {
      background-color: transparent;
      color: ${({ theme }) => theme.COLOR_PRIMARY};
      span {
        color: ${({ theme }) => theme.COLOR_PRIMARY};
      }
    }
  }
  &:disabled {
    cursor: not-allowed;
    background-color: transparent;
    span {
      color: ${({ theme }) => theme.COLOR_GREY3};
    }
  }
`;

const StyledButton = {
  ButtonText,
  ButtonTextDark,
  EttxPrimaryButton,
  Button,
  InnerButtonContainer,
  EttxPrimaryOutlineButton,
  EttxTextButton,
  IconContainer,
  IconContainerRight,
};

export default StyledButton;
